import React from "react";
import Contact from "../components/Contact.js";
import GetInTouch from "../components/GetInTouch.js";


const QAServices = () => {
  const testings = [
    {
      icon: "./assets/icons/techIcons/icon1.png",
      title: "Requirement Analysis",
    },
    {
      icon: "./assets/icons/techIcons/icon2.png",
      title: "Create Test Plans and Test Cases",
    },
    {
      icon: "./assets/icons/techIcons/icon3.png",
      title: "Execute Test Cases and Document Bugs",
    },
    {
      icon: "./assets/icons/techIcons/icon4.png",
      title: "Revalidate Fixed Issues",
    },
    {
      icon: "./assets/icons/techIcons/icon5.png",
      title: "Conduct Regression Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon6.png",
      title: "Prepare Test Summary Reports",
    },
    {
      icon: "./assets/icons/techIcons/icon7.png",
      title: "Perform Functional Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon8.png",
      title: "Ensure Compatibility Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon9.png",
      title: "Load and Performance Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon10.png",
      title: "End-to-End System Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon11.png",
      title: "User Acceptance Testing (UAT)",
    },
    {
      icon: "./assets/icons/techIcons/icon12.png",
      title: "Perform Security Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon13.png",
      title: "Accessibility Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon14.png",
      title: "Automated Testing for Repetitive Scenarios",
    },
    {
      icon: "./assets/icons/techIcons/icon15.png",
      title: "Cross-Browser and Cross-Platform Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon16.png",
      title: "Mobile Application Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon17.png",
      title: "Integration Testing for Interfaces",
    },
    {
      icon: "./assets/icons/techIcons/icon18.png",
      title: "Risk-Based Testing",
    },
    {
      icon: "./assets/icons/techIcons/icon19.png",
      title: "Continuous Testing in CI/CD Pipelines",
    },
    {
      icon: "./assets/icons/techIcons/icon20.png",
      title: "Monitor and Report Defect Trends",
    },
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="flex flex-col items-center justify-center py-10 mt-20">
      <div className=" rounded-lg p-10 py-20 max-w-5xl text-center mb-20">
        <h1 className="sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4">
          QA Expertise
        </h1>
        <p className="text-lg text-gray-800 mb-2">
          Experience unparalleled quality assurance with our state-of-the-art QA
          services. Step into a world where precision and excellence converge to
          elevate your software above the rest.
        </p>
        <button
          onClick={() =>
            window.scrollTo({ top: window.innerHeight, behavior: "smooth" })
          }
          className="mt-20 mb-10 bg-blue-700 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition duration-300"
        >
          Get Started
        </button>
      </div>

      <div className=" py-5 px-5 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
          <div className="flex justify-center lg:w-1/4 mb-12 lg:mb-0">
            <img
              src="\assets\images\qaServices/img1.webp"
              alt="QA Services"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="lg:w-3/4 text-center lg:text-left p-6">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-2">
              Delivering Excellence Through QA Services
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              In the fast-paced digital era, achieving outstanding quality is
              critical. Our QA services go far beyond simple testing; they
              reflect our dedication to enhancing every application and solution
              to the highest level. Instead of just adhering to standards, we
              aim to redefine them.
              <br />
              <br />
              By leveraging innovative methodologies, we streamline testing
              workflows to save both time and resources, ensuring cost-effective
              outcomes without compromising quality. Our QA approach ensures
              clear reporting and exceptional performance. Every project we
              undertake undergoes a thorough evaluation, meeting not only
              top-tier quality benchmarks but also the unique needs of each
              client.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full max-w-7xl bg-blue-800 text-white py-8 px-4 rounded-2xl mt-10 mx-auto ">
        <div className=" mx-auto text-center flex justify-center md:justify-between items-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl  mb-2 px-10">
            Elevate Your Business to the Next Level!
          </h2>
          <button
            onClick={scrollToContact}
            className="bg-green-500 px-4 py-2 ml-6 rounded-full "
          >
            Get Started
          </button>
        </div>
      </div>

      <div className=" py-12 px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Ayanshtech QA Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Delivering flawless quality through expert testing solutions.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {testings.map((step, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="transform transition duration-300 ease-in-out hover:scale-110">
                <img
                  src={step.icon}
                  alt={step.title}
                  className="w-18 h-16 mb-4 px-10"
                />
              </div>
              <p className="text-center font-bold">{step.title}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center my-16">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
          Adding Exceptional Value
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-700 font-medium mt-6 max-w-6xl mx-auto">
          Our expert QA team ensures efficient product delivery, resource
          optimization, and superior quality at every stage.
        </p>
      </div>

      <div className=" p-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Image Section */}
          <div className="w-24 md:w-1/2 p-5">
            <img
              src="\assets\images\qaServices/qa2.jpg"
              alt="Analytics on laptop"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-cover"
            />
          </div>

          {/* Text Section with Two Columns */}
          <div className="md:w-1/2 lg:w-3/4 p-5 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex items-start space-x-5">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="cost-saving icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Minimize expenses by ensuring a flawless and seamless solution
                from the outset.
              </p>
            </div>

            <div className="flex items-start space-x-5">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="adaptability icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Keep your software solutions, including VoIP, agile to adapt to
                changing business demands.
              </p>
            </div>

            <div className="flex items-start space-x-5">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="custom solutions icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Utilize our expertise in open-source telephony to create
                tailored solutions that meet your specific needs.
              </p>
            </div>

            <div className="flex items-start space-x-5">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="team augmentation icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Rapidly scale your technical teams with our flexible on-demand
                developer support across multiple technologies.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="contact-section">
        <Contact />
      </div>

      <GetInTouch />
    </div>
  );
};

export default QAServices;
